import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EmojiModule} from '@ctrl/ngx-emoji-mart/ngx-emoji';
import {PipesModule} from '../../core/pipes/pipes.module';
import {isStandardReaction} from '../../core/helpers/reaction-display.helper';

@Component({
  selector: 'app-reaction-emoji',
  standalone: true,
  imports: [CommonModule, EmojiModule, PipesModule],
  styles: [':host { display: inline-flex; align-items: center; vertical-align: middle; line-height: 1; }'],
  template: `
    <ngx-emoji *ngIf="isStandard(reactedWith); else custom" [emoji]="reactedWith | reactionClassMap" [size]="size"></ngx-emoji>
    <ng-template #custom>
      <span role="img" [attr.aria-label]="reactedWith" [style.font-size.px]="size">{{ reactedWith }}</span>
    </ng-template>
  `,
})
export class ReactionEmojiComponent {
  @Input() reactedWith: string;
  @Input() size = 16;
  public readonly isStandard = isStandardReaction;
}
